/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiExportFileType,
    InternalApiExportFileTypeFromJSON,
    InternalApiExportFileTypeToJSON,
    InternalApiPersonTransactionsSummary,
    InternalApiPersonTransactionsSummaryFromJSON,
    InternalApiPersonTransactionsSummaryToJSON,
    InternalApiTransactionDirection,
    InternalApiTransactionDirectionFromJSON,
    InternalApiTransactionDirectionToJSON,
    InternalApiTransactionSummaryByAccount,
    InternalApiTransactionSummaryByAccountFromJSON,
    InternalApiTransactionSummaryByAccountToJSON,
} from '../models';

export interface GetPersonTransactionSummaryByAccountRequest {
    personId: string;
    page: number;
    size: number;
    direction: InternalApiTransactionDirection;
    from: Date;
    to: Date;
    transactionType?: string;
}

export interface GetPersonTransactionsSummaryRequest {
    personId: string;
    from: Date;
    to: Date;
    transactionType?: string;
}

export interface GetPersonTransactionsSummaryExportRequest {
    personId: string;
    from: Date;
    to: Date;
    fileType: InternalApiExportFileType;
    transactionType?: string;
}

export interface GetPersonTransactionsSummaryExportResponse {
    headers: Headers;
    body: Blob;
}

/**
 * 
 */
export class TransactionSummaryV2Api extends runtime.BaseAPI {

    /**
     * Fetches additional accounts aggregation
     */
    async getPersonTransactionSummaryByAccountRaw(requestParameters: GetPersonTransactionSummaryByAccountRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiTransactionSummaryByAccount>>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getPersonTransactionSummaryByAccount.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getPersonTransactionSummaryByAccount.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling getPersonTransactionSummaryByAccount.');
        }

        if (requestParameters.direction === null || requestParameters.direction === undefined) {
            throw new runtime.RequiredError('direction','Required parameter requestParameters.direction was null or undefined when calling getPersonTransactionSummaryByAccount.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getPersonTransactionSummaryByAccount.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getPersonTransactionSummaryByAccount.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = (requestParameters.from as any).toISOString().substr(0,10);
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = (requestParameters.to as any).toISOString().substr(0,10);
        }

        if (requestParameters.transactionType !== undefined) {
            queryParameters['transactionType'] = requestParameters.transactionType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/transactions-summary/accounts`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiTransactionSummaryByAccountFromJSON));
    }

    /**
     * Fetches additional accounts aggregation
     */
    async getPersonTransactionSummaryByAccount(requestParameters: GetPersonTransactionSummaryByAccountRequest, initOverrides?: RequestInit): Promise<Array<InternalApiTransactionSummaryByAccount>> {
        const response = await this.getPersonTransactionSummaryByAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches persons transactions summary
     */
    async getPersonTransactionsSummaryRaw(requestParameters: GetPersonTransactionsSummaryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiPersonTransactionsSummary>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getPersonTransactionsSummary.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getPersonTransactionsSummary.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getPersonTransactionsSummary.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = (requestParameters.from as any).toISOString().substr(0,10);
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = (requestParameters.to as any).toISOString().substr(0,10);
        }

        if (requestParameters.transactionType !== undefined) {
            queryParameters['transactionType'] = requestParameters.transactionType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/transactions-summary`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiPersonTransactionsSummaryFromJSON(jsonValue));
    }

    /**
     * Fetches persons transactions summary
     */
    async getPersonTransactionsSummary(requestParameters: GetPersonTransactionsSummaryRequest, initOverrides?: RequestInit): Promise<InternalApiPersonTransactionsSummary> {
        const response = await this.getPersonTransactionsSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches persons transactions summary is csv format
     */
    async getPersonTransactionsSummaryExportRaw(requestParameters: GetPersonTransactionsSummaryExportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getPersonTransactionsSummaryExport.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getPersonTransactionsSummaryExport.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getPersonTransactionsSummaryExport.');
        }

        if (requestParameters.fileType === null || requestParameters.fileType === undefined) {
            throw new runtime.RequiredError('fileType','Required parameter requestParameters.fileType was null or undefined when calling getPersonTransactionsSummaryExport.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = (requestParameters.from as any).toISOString().substr(0,10);
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = (requestParameters.to as any).toISOString().substr(0,10);
        }

        if (requestParameters.transactionType !== undefined) {
            queryParameters['transactionType'] = requestParameters.transactionType;
        }

        if (requestParameters.fileType !== undefined) {
            queryParameters['fileType'] = requestParameters.fileType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/transactions-summary/export`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Fetches persons transactions summary is csv format
     */
    async getPersonTransactionsSummaryExport(requestParameters: GetPersonTransactionsSummaryExportRequest, initOverrides?: RequestInit): Promise<GetPersonTransactionsSummaryExportResponse> {
        const response = await this.getPersonTransactionsSummaryExportRaw(requestParameters, initOverrides);
        return {
          headers: response.raw.headers,
          body: await response.value(),
        };
    }

}
